import {
  ApiEditUser,
  ApiOrganisationType,
  NewUserCommand
} from '../../../api/_legacy/generated-api'
import { BankUser } from '../types'

export function mapBankUserToUserApiCreateRequest(
  user: BankUser,
  userName: string
): NewUserCommand {
  const userRequest = {
    userName,
    password: 'Administrator01',
    roles: [user.role],
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    organisation: {
      organisationType: 'Bank' as ApiOrganisationType,
      organisationId: 'Absa',
      organisationName: 'Absa'
    },
    requiresConfirmation: true,
    requiresTwoFactor: true
  }
  return userRequest
}

export function mapBankUserToUserApiEditRequest(user: BankUser, oldRole: string): ApiEditUser {
  const userRequest = {
    userName: user.userName,
    rolesToAdd: [user.role],
    rolesToRemove: [oldRole],
    firstName: user.firstName,
    lastName: user.lastName
  }
  return userRequest
}
